(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-br-collection-filter]').forEach((filterPanel) => {
      if (filterPanel.dataset.brFilterInitialised === 'true') return;

      const collectionRoot = filterPanel.closest('[data-br-collection-root]');
      const productGrid = collectionRoot?.querySelector('#product-grid');
      if (!productGrid) return;

      const buttons = [...filterPanel.querySelectorAll('[data-br-drink-filter]')];
      const products = [...productGrid.querySelectorAll(':scope > [data-br-drink-groups]')];
      const status = filterPanel.querySelector('[data-br-filter-status]');
      const empty = filterPanel.querySelector('[data-br-filter-empty]');

      const applyFilter = (filter) => {
        let visibleCount = 0;

        products.forEach((product) => {
          const groups = (product.dataset.brDrinkGroups || '').split(/\s+/).filter(Boolean);
          const matches = filter === 'all' || groups.includes(filter);
          product.hidden = !matches;
          product.setAttribute('aria-hidden', matches ? 'false' : 'true');
          if (matches) visibleCount += 1;
        });

        buttons.forEach((button) => {
          button.setAttribute('aria-pressed', button.dataset.brDrinkFilter === filter ? 'true' : 'false');
        });

        if (status) {
          status.textContent = filter === 'all'
            ? `Showing all ${visibleCount} coffees.`
            : `Showing ${visibleCount} of ${products.length} coffees.`;
        }
        if (empty) empty.hidden = visibleCount !== 0;
      };

      filterPanel.addEventListener('click', (event) => {
        const button = event.target.closest('[data-br-drink-filter]');
        if (!button || !filterPanel.contains(button)) return;
        applyFilter(button.dataset.brDrinkFilter);
      });

      filterPanel.dataset.brFilterInitialised = 'true';
      applyFilter('all');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
